

//获取时间的字符串格式
//format ：'M' > YYYY年MM月DD日
//         'm' > YYYY-MM-DD
//		'H' > YYYY年MM月DD日 HH:mm
// 		'h' > YYYY-MM-DD HH:mm
function dateformat (date, format) {
  if (!date)
    return '';
  var pdate = date;
  if (!(pdate instanceof Date))
  {
    if (date.indexOf('-') > 0)
    {
      var temp = date.replace(/-/g, '/').replace('T', ' ');
      pdate = new Date(temp);
    } else
      pdate = new Date(date);
  }
  var year = pdate.getFullYear();
  var tm = pdate.getMonth() + 1
  var month = tm < 10 ? '0' + tm : tm;
  var day = pdate.getDate() < 10 ? '0' + pdate.getDate() : pdate.getDate();
  var hour = pdate.getHours() < 10 ? "0" + pdate.getHours() : pdate.getHours();
  var minute = pdate.getMinutes() < 10 ? "0" + pdate.getMinutes() : pdate.getMinutes();
  if (format == 'M')
    return year + '年' + month + '月' + day + '日 ';
  else if (format == 'm')
    return year + '-' + month + '-' + day;
  else if (format == 'H')
    return year + '年' + month + '月' + day + '日 ' + hour + ':' + minute;
  else if (format == 'h')
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
  else
    return year + '年' + month + '月' + day + '日 ';
}
function getCookie (name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
}

function delCookie (name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ";path=/";
}

function setCookie (name, value) {
  var Days = 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/";
}
export function syntaxHighlight (json) {
  if (typeof json != 'string')
  {
    json = JSON.stringify(json, undefined, 2);
  }
  json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
    var cls = 'number';
    if (/^"/.test(match))
    {
      if (/:$/.test(match))
      {
        cls = 'key';
      } else
      {
        cls = 'string';
      }
    } else if (/true|false/.test(match))
    {
      cls = 'boolean';
    } else if (/null/.test(match))
    {
      cls = 'null';
    }
    return '<span class="' + cls + '">' + match + '</span>';
  });
}

export default {
  install (Vue, options) {
    Vue.prototype.$dateformat = dateformat;
    Vue.prototype.$getCookie = getCookie;
    Vue.prototype.$setCookie = setCookie;
    Vue.prototype.$delCookie = delCookie;
  }
}


// WEBPACK FOOTER //
// ./src/utils/common.js